import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("6ftc0"), parcelRequire.load("9f8mp"), parcelRequire.load("iJCl6"), parcelRequire.load("iCNtT"), parcelRequire.load("jkk6G"), parcelRequire.load("k0Vga")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("6ftc0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("iJCl6")} />
  <link rel="modulepreload" href={parcelRequire.resolve("iCNtT")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jkk6G")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k0Vga")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
